import { formatPrice, formatCurrency } from '@popety_io/popety-io-lib'
import {
  ESTIMATE_PURCHASE_APARTMENT,
  ESTIMATE_PURCHASE_HOUSE,
  MIN_PRICE_PURCHASE,
  MAX_PRICE_PURCHASE,
  MIN_PRICE_RENT,
  MAX_PRICE_RENT,
  ESTIMATE_RENT_APARTMENT,
  ESTIMATE_RENT_HOUSE,
} from '../../../config'

const min = MIN_PRICE_PURCHASE
const max = MAX_PRICE_PURCHASE
const diff = max - min

const minRent = MIN_PRICE_RENT
const maxRent = MAX_PRICE_RENT
const diffRent = maxRent - minRent

const pricingLegend = () => [
  { value: `< ${formatPrice(min)}`, color: '#5e4fa2' },
  {
    value: `${formatPrice(min)} - ${formatCurrency(min + Math.round(diff / 8) * 1, '')}`,
    color: '#3288bd',
  },
  {
    value: `${formatPrice(min + Math.round(diff / 8) * 1)} - ${formatCurrency(min + Math.round(diff / 8) * 2, '')}`,
    color: '#66c2a5',
  },
  {
    value: `${formatPrice(min + Math.round(diff / 8) * 2)} - ${formatCurrency(min + Math.round(diff / 8) * 3, '')}`,
    color: '#abdda4',
  },
  {
    value: `${formatPrice(min + Math.round(diff / 8) * 3)} - ${formatCurrency(min + Math.round(diff / 8) * 4, '')}`,
    color: '#e6f598',
  },
  {
    value: `${formatPrice(min + Math.round(diff / 8) * 4)} - ${formatCurrency(min + Math.round(diff / 8) * 5, '')}`,
    color: '#fee08b',
  },
  {
    value: `${formatPrice(min + Math.round(diff / 8) * 5)} - ${formatCurrency(min + Math.round(diff / 8) * 6, '')}`,
    color: '#fdae61',
  },
  {
    value: `${formatPrice(min + Math.round(diff / 8) * 6)} - ${formatCurrency(min + Math.round(diff / 8) * 7, '')}`,
    color: '#f46d43',
  },
  {
    value: `${formatPrice(min + Math.round(diff / 8) * 7)} - ${formatCurrency(min + Math.round(diff / 8) * 8, '')}`,
    color: '#d53e4f',
  },
  { value: `> ${formatPrice(max)}`, color: '#9e0142' },
]

const pricingLegendRent = () => [
  { value: `< ${formatPrice(minRent)}`, color: '#5e4fa2' },
  {
    value: `${formatPrice(minRent)} - ${formatCurrency(minRent + Math.round(diffRent / 8) * 1, '')}`,
    color: '#3288bd',
  },
  {
    value: `${formatPrice(minRent + Math.round(diffRent / 8) * 1)} - ${formatCurrency(minRent + Math.round(diffRent / 8) * 2, '')}`,
    color: '#66c2a5',
  },
  {
    value: `${formatPrice(minRent + Math.round(diffRent / 8) * 2)} - ${formatCurrency(minRent + Math.round(diffRent / 8) * 3, '')}`,
    color: '#abdda4',
  },
  {
    value: `${formatPrice(minRent + Math.round(diffRent / 8) * 3)} - ${formatCurrency(minRent + Math.round(diffRent / 8) * 4, '')}`,
    color: '#e6f598',
  },
  {
    value: `${formatPrice(minRent + Math.round(diffRent / 8) * 4)} - ${formatCurrency(minRent + Math.round(diffRent / 8) * 5, '')}`,
    color: '#fee08b',
  },
  {
    value: `${formatPrice(minRent + Math.round(diffRent / 8) * 5)} - ${formatCurrency(minRent + Math.round(diffRent / 8) * 6, '')}`,
    color: '#fdae61',
  },
  {
    value: `${formatPrice(minRent + Math.round(diffRent / 8) * 6)} - ${formatCurrency(minRent + Math.round(diffRent / 8) * 7, '')}`,
    color: '#f46d43',
  },
  {
    value: `${formatPrice(minRent + Math.round(diffRent / 8) * 7)} - ${formatCurrency(minRent + Math.round(diffRent / 8) * 8, '')}`,
    color: '#d53e4f',
  },
  { value: `> ${formatPrice(maxRent)}`, color: '#9e0142' },
]

export const pricingOptions = (t: Translator) => {
  return [
    {
      value: ESTIMATE_PURCHASE_APARTMENT,
      label: t('common.estimate-purchase-apartment-v1'),
      legend: pricingLegend(),
      group: 'environment',
    },
    {
      value: ESTIMATE_PURCHASE_HOUSE,
      label: t('common.estimate-purchase-house-v1'),
      legend: pricingLegend(),
      group: 'environment',
    },
    {
      value: ESTIMATE_RENT_APARTMENT,
      label: t('common.estimate-purchase-apartment-v1'),
      legend: pricingLegendRent(),
      group: 'environment',
    },
    {
      value: ESTIMATE_RENT_HOUSE,
      label: t('common.estimate-purchase-house-v1'),
      legend: pricingLegendRent(),
      group: 'environment',
    },
  ]
}
